var render, staticRenderFns
import script from "./BaseResizeObserver.vue?vue&type=script&lang=ts"
export * from "./BaseResizeObserver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@7.1.4_webpack@5.105.3__ejs@3.1.1_a26f30fb19caf7f85e132ae92399ad32/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports